export default {
  // TITLE
  TitleControl: '',
  ShowTitleControl: { checked: true },
  StyleTitleControl: {
    fontSize: 20,
    color: '#000000',
    fontFamily: 'arial',
    bold: false,
    italic: false,
    underline: false,
    align: 'center',
  },
  // Drilldown
  DrilldownStyle: 'auto',
  // GENERAL
  SortColumnsControl: 'Não ordenado',
  CustomSortColumnControl: {
    checked: false, kpiCategories: [],
  },
  SortValuesControl: 'Não ordenado',
  ColumnToSortControl: 'index',
  CustomSortControl: {
    checked: false, kpiCategories: [],
  },
  LineShowTotalControl: true,
  ColumnShowTotalControl: true,
  LineOnlyShowTotalControl: false,
  ColumnOnlyShowTotalControl: false,
  MinValueControl: { value: 0, checked: true },
  MaxValueControl: { value: 0, checked: true },
  ExtendDateLine: false,
  ExtendDateColumn: false,
  DataFormat: 'absolute', // { type: 'absolute', target: 'global' },
  DataPercentFormat: 'global',
  DataAbsoluteFormat: 'number',
  DataFormatAlt: 'none',
  DataPercentFormatAlt: 'global',
  DataAbsoluteFormatAlt: 'number',
  DurationUnit: 'hours',
  // LABEL
  LabelsFontFamilyControl: { value: 'arial' },
  LabelsFontSizeControl: { value: 14 },
  LineColorControl: 'single',
  RowColor: 'white',
  StripedRowsColor: 'white',
  HeaderColor: 'white',
  PrefixControl: '',
  SufixControl: '',
  Decimals: 'auto',
  separadorNumericoCasas: '0',
  LabelCurrencyControl: 'Nenhum',
  LabelGroupingControl: 'Nenhum',
  UseGlobalColor: true,
  UseGlobalFont: true,
  // AXIS
  EnableGridX: true,
  EnableGridY: true,
  GridColor: '#EEE',
};
